import { FC } from 'react';
import ChildNodes from './ChildNodes';
import Contents from './Contents';
import { useBookPageContext } from '@utils/context/book';

const Previews: FC = () => {
    const { previewsContent: contents } = useBookPageContext();

    if (!contents || !contents.length) return <ChildNodes />;

    return <Contents contents={contents} />;
};

export default Previews;
